import { Star } from 'lucide-react';
import React from 'react';
import Select from 'react-select';
import clsx from 'clsx';

const SingleSelectSearch = ({
  value,
  onChange,
  options = [],
  disabled = false,
  className,
  tabIndex,
  showAssignedHeader = false,
  placeholder = "Select Industry",
  contentClass = "",
  itemClass = "",
}) => {
  const selectedOption = options?.find((opt) => opt?.value === value) || null;
  const selectOne = options?.find((opt) => opt?.value === "All");
  const filteredOptions = options?.filter((opt) => opt?.value !== "All");

  const assigned = filteredOptions?.filter((opt) => opt.apptEmp);
  const unassigned = filteredOptions?.filter((opt) => !opt.apptEmp);

  const groupedOptions = showAssignedHeader
    ? [
      {
        label: "⭐ Assigned Employees",
        options: [
          ...(selectOne ? [selectOne] : []),
          ...assigned,
          ...unassigned,
        ],
      },
    ]
    : options;
  return (
    <div>
      <Select
        tabIndex={tabIndex}
        value={selectedOption}
        className={className}
        onChange={(selected) => onChange(selected?.value)}
        options={groupedOptions}
        isSearchable
        placeholder={placeholder}
        isDisabled={disabled}
        formatOptionLabel={(option) =>
          option?.options ? (
            option?.formatOptionLabel
          ) : (
            <div className="flex items-center">
              <div className="w-4 flex justify-center">
                {option?.apptEmp ? (
                  <Star size={14} className="text-amber-500" />
                ) : null}
              </div>
              <span>{option?.label}</span>
            </div>
          )
        }
        classNames={{
          control: () => clsx(contentClass),
          menu: () => clsx(contentClass),
          option: () => clsx(itemClass),
        }}
        styles={{
          control: (base, state) => ({
            ...base,
            height: 40,
            borderRadius: 8,
            borderColor: state.isFocused ? '#85bdfd' : '#ccc',
            boxShadow: state.isFocused ? '0 0 0 2px #bcd6f6' : 'none',
            '&:hover': {
              borderColor: '#85bdfd',
            },
            ...(contentClass && {
              backgroundColor: 'inherit',
            }),
          }),
          valueContainer: (base) => ({
            ...base,
            padding: '0 8px',
          }),
          indicatorSeparator: () => ({
            display: 'none',
          }),
          input: (base) => ({
            ...base,
            color: 'inherit',
          }),
          dropdownIndicator: (base, state) => ({
            ...base,
            color: state.isFocused ? '#2980ba' : '#666',
            '&:hover': {
              color: '#2980ba',
            },
          }),
          option: (base, state) => ({
            ...base,
            backgroundColor: 'transparent',
            color: 'inherit',
            cursor: 'pointer',
            padding: '10px 0px',
          }),
          menu: (base) => ({
            ...base,
            borderRadius: 6,
            boxShadow: '0 4px 10px rgba(0,0,0,0.08)',
            zIndex: 20,
            backgroundColor: 'inherit',
          }),
          singleValue: (base) => ({
            ...base,
            color: 'inherit', // Gray-900
          }),
          placeholder: (base) => ({
            ...base,
            color: 'inherit', // Gray-400
          }),
          clearIndicator: (base) => ({
            ...base,
            padding: '0 4px',
            color: '#888',
            '&:hover': { color: '#000' },
          }),
        }}
      />
    </div>
  );
};

export default SingleSelectSearch;
